/**
 * 数科-短信营销落地页-挽留弹窗 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-短信营销落地页-挽留弹窗
 * uuid:3f6100026c81444188bea55d80de7ae0
 */

import { Vue, Component } from 'vue-property-decorator';
import AdvCommonContainer from '../adv-common-container';

export const marketingBackId = '3f6100026c81444188bea55d80de7ae0';
@Component
export default class AdvMarketingBackPopup extends Vue {
  private clickTrack() {
    this.$ubtPageButton('finance_smsMarketing_landingPage_backPopup');
  }

  private confirm() {
    this.$emit('confirm');
    this.clickTrack();
  }

  private cancel() {
    this.$emit('cancel');
    this.clickTrack();
  }

  private render() {
    return (
       <AdvCommonContainer
         advMasterId={marketingBackId}
         onCancel={this.cancel.bind(this)}
         onConfirm={this.confirm.bind(this)}
         customClickConfirm="true"
         useDefaultGeo={true}
       />
    );
  }
}
